import { render, staticRenderFns } from "./ConfirmPropertyAddresses.vue?vue&type=template&id=4ec6cff9"
import script from "./ConfirmPropertyAddresses.vue?vue&type=script&lang=js"
export * from "./ConfirmPropertyAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports